module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2i"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/intro.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentc"
  }, [_vm._v("I don’t know how they do it—at cocktails parties, that is. Women, especially, holding wine glass in one hand, cocktail napkin or plate in the other hand, and niftily plucking hors d’oeuvres off a passed silver tray, all the while clutching an elegant little purse under her arm. Men, of course, "), _c('em', [_vm._v("sans")]), _vm._v(" purse, have one less thing to worry about, but it’s a juggling act nonetheless. The bigger challenge comes when a cocktail glass replaces the wine glass. One tiny bump from a passerby sends the cosmo or martini sloshing over the side of the glass, splashing the new, or freshly dry-cleaned, cocktail attire of a neighboring guest.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Is it obvious that I’m a bit of a social observer? Of course, I’m fully engaged, even enthralled at times, by cocktail conversation, but I can’t help observing the skills needed to simultaneously eat, hold a glass, and conduct sparkling conversation at such affairs. The food alone can pose quite a challenge. Those one-bite-fits-all hors d’oeuvres aren’t always one bite. Nor are they conveniently tidy. Too big, and those topped-toast-point savories shatter upon the first bite. Too runny, and those Parmesan cheese–stuffed mushrooms ooze juice between the fingers. Too crispy, and those phyllo-wrapped triangles send cascades of flakes to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I’m not really a klutz; my husband and friends can attest to that, but I don’t manage well at these types of parties. I fear being bumped, dread the thought of a too-crispy canapé, and know I’ll be introduced to some charming guest just when I’ve plunked an hors d’oeuvre in my mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("This brings me to dips. I love dips. I wouldn’t have written this book if I didn’t like dips! Let me tell you why. When I see a dip and a delectable bowl of chips set on a buffet or cocktail table, I can easily sidle up to the table, set down my glass, and have a hand free for scooping and crunching—the juggling act is over. Now, I’m free to chat without the worry of a spill.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Dips allow for social engineering; set out on a buffet or cocktail table, they change the "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("way guests mingle. Put out small plates and individual hors d’oeuvres and guests will walk around a table or move along a buffet, pick and choose to fill their plate, and move away. Set out a dip or two, in different spots, and guests will congregate—happily scooping and crunching as different conversations blossom. Dips become a positive social mechanism—an icebreaker of sorts—for getting guests acquainted. (That is, of course, unless a guest double-dips a half-eaten chip. But who invites those sorts of guests, anyway?)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The same holds true for manipulating your guests when you want them out of the kitchen and into the living room. Set dips and chips on a cocktail table, point the way, and before you know it the group has eased into chairs, settled on the sofa, set glasses on coasters, and begun diving into a bowlful of crispy delights.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Dips are easy on the host—no fussy hors d’oeuvres to assemble and delicately garnish. Rarely are dips last-minute affairs involving split-second timing and finesse. Most dips are stirred, whipped, or whirled, and then scooped into a serving bowl. And chips are a cinch to make, too. The novice cook can feel relaxed; just make the dip and open a bag or two of high-quality crunchy dippers—tortilla, bagel, and even vegetable chips. Dips are so easy, in fact, the cook looking for fun and play in the kitchen will have time to prepare them "), _c('em', [_vm._v("and")]), _vm._v(" the perfect crisps and chips to accompany them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('em', [_vm._v("Delicious Dips")]), _vm._v(" includes over fifty contemporary recipes capturing global flavors and tastes. Look at the “Ingredient Glossary, Dip Tips, and Deep Frying Techniques for Chips” ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#page_12"
    }
  }, [_vm._v("page 12")]), _vm._v("), for an insider’s guide to such essentials as handling and roasting chiles, toasting nuts and spices, and roasting garlic. I couldn’t call myself a champion of chips if I didn’t share all I know about deep-frying and baking chips. Then, you’ll see how addictively fun and easy it can be to make homemade chips in “Crudités, Chips, Crisps, and Other Dippers” ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 95")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindentlt"
  }, [_vm._v("The recipes included in the book have all been family- and friend-tested. The winners remain; the duds were axed. You’ll see classics with a twist, such as the Baked Artichoke-Parmesan Dip ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#page_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 22")]), _vm._v(") and the Grilled Eggplant and Garlic Dip ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#page_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 36")]), _vm._v(") in “Vegetables and Herb Dips” ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 21")]), _vm._v("). Plus check out sultry lip-buzzing “Salsas and Guacamoles” ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 41")]), _vm._v(") or look to “Cheese, Bean, Legume, and Tofu Dips” ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 57")]), _vm._v("). Hearty meat and seafood dips such as Shanghai Shrimp Dip ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 70")]), _vm._v(") or Chorizo Chile Con Queso ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#page_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 78")]), _vm._v(") "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("pack a lot of flavor into a single bowl. For a sweet finale, dip into “Dessert Dips” ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 83")]), _vm._v(") and delight your guests with smooth and rich Caramel and Dark Rum Fondue ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 89")]), _vm._v("), or make the wickedly easy and sensationally delicious Chocolate Mocha Mascarpone Dip ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 86")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("To make your entertaining and planning easier, I have included a “Dip Do-Ahead” with each recipe. You’ll know how far in advance a recipe can be made, how to store it, and how to reheat the dip if that’s what’s called for. In addition, I’ve given you chip and dip pairings for each recipe, called “Dippables.” These are my favorite combos for the dips and chips. While I have primarily paired the dips with homemade chips from “Crudités, Chips, Crisps, and Other Dippers” ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 95")]), _vm._v("), I have included store-bought chip suggestions as well.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I say, “Chips ahoy,” and get that oil hot for some of the crispiest, crunchiest, most mouth-satisfying dippers you’ve ever tasted. Unstoppable for eating, unbeatable for taste, homemade chips are a cook’s playground of fun. Sharpen those knives, get out the mandoline, and fry up some paper-thin slices of sweet potato, yucca, and carrots. Don’t forget wontons, oh, and some tortillas and bagel chips, too. Make it a crunch fest for your guests.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3f"
  }, [_vm._v("Dip freely, crunch happily, munch on!")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/intro01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee3c7f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 72
// module chunks = 0